var React = require('react');

function Workplace (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.5 5.10156V11.9016H1.5V5.10156H14.5ZM16 3.60156H0V13.4016H16V3.60156Z","fill":"#E47C6E","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.5998 1.75C6.31402 1.75 6.0498 2.01421 6.0498 2.3V4.5H4.5498V2.3C4.5498 1.18579 5.48558 0.25 6.5998 0.25H9.2998C10.414 0.25 11.3498 1.18578 11.3498 2.3V4.5H9.84981V2.3C9.84981 2.01422 9.58559 1.75 9.2998 1.75H6.5998Z","fill":"#E47C6E","key":1})]);
}

Workplace.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none"};

module.exports = Workplace;

Workplace.default = Workplace;
